// Sticky Banner Manager - Handles dynamic positioning of banner and header
document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('.announcement-bar-section');
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  const stickyHeader = document.querySelector('.shopify-section-header-sticky');

  const isStickyEnabled = banner?.classList.contains('announcement-bar-section--sticky');

  if (!isStickyEnabled || !banner || !headerGroup) {
    return;
  }

  // Debounce function for resize events
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function updatePositions() {
    const bannerHeight = banner.offsetHeight;

    // Set CSS custom property for dynamic height
    document.documentElement.style.setProperty('--sticky-banner-height', `${bannerHeight}px`);

    // Apply sticky styles to banner
    banner.style.position = 'fixed';
    banner.style.top = 0;
    banner.style.left = 0;
    banner.style.right = 0;
    banner.style.zIndex = 11; // Above header group (10)
    banner.style.width = '100%';

    // Remove any margins/borders that might cause gap
    banner.style.marginBottom = 0;
    banner.style.borderBottom = 'none';
    headerGroup.style.marginTop = 0;
    headerGroup.style.borderTop = 'none';

    // Push header group down by banner height (subtract 1px to prevent gap on mobile)
    const adjustedHeight = Math.ceil(bannerHeight) - 1;
    headerGroup.style.position = 'relative';
    headerGroup.style.top = `${adjustedHeight}px`;
    headerGroup.style.transition = 'top 0.3s ease';

    // Also update sticky header if it exists
    if (stickyHeader) {
      stickyHeader.style.top = `${adjustedHeight}px`;
    }

    // Add padding to body to prevent content jump (use original height)
    document.body.style.paddingTop = `${Math.ceil(bannerHeight)}px`;

    document.querySelector('sticky-header')?.scheduleHeaderOffsetUpdate?.();
  }

  updatePositions();

  window.addEventListener('resize', debounce(updatePositions, 150));

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId.includes('top-banner')) {
        setTimeout(updatePositions, 100);
      }
    });

    document.addEventListener('shopify:section:reorder', function () {
      setTimeout(updatePositions, 100);
    });
  }
});
